import React, { useState, useEffect } from "react";
import _ from "lodash-es";
import { useIntl } from "react-intl";

import { useTheme } from "@mui/styles";
import {
  StyledDemoTemplateContainer,
  StyledDemoTemplate,
  StyledHeaderContainer,
  StyledHeaderTitle,
  StyledHeaderContent,
  StyledContentContainer,
  StyledInputContainer,
  StyledInput,
  StyledInputFakeButton,
  StyledFakeButton,
  StyledContentText,
} from "./OptInDemoTemplate.styles";

export function hexToRgb(hex) {
  if (!hex) return null;

  // 先去掉 # 號
  hex = hex.replace("#", "");

  // 根據長度補齊或裁剪
  if (hex.length === 3) {
    // 3位 → 6位
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  } else if (hex.length === 4) {
    // 4位 → 8位 (RGBA)
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  } else if (hex.length === 5 || hex.length === 7) {
    // 5位或7位 → 視為錯誤，丟掉多的位數
    hex = hex.slice(0, 6);
  } else if (hex.length !== 6 && hex.length !== 8) {
    // 其他長度都不合法
    console.warn(`Invalid hex color format: #${hex}`);
    return null;
  }

  // 轉成RGB數值
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  const a =
    hex.length === 8 ? (parseInt(hex.slice(6, 8), 16) / 255).toFixed(2) : null;

  if (a !== null) {
    return { r, g, b, a: Number(a) }; // rgba
  } else {
    return { r, g, b, a: 1 }; // rgb
  }
}

export const getBrightness = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return;
  const { r, g, b, a } = rgb;
  // 計算亮度
  return (r * 299 + g * 587 + b * 114) / a / 1000;
};

export const textWithDynamicColor = (
  bgColor,
  darkTextColor,
  lightTextColor
) => {
  // 計算背景顏色的亮度
  const brightness = getBrightness(bgColor);
  // 根據亮度選擇文字顏色
  return brightness > 128 ? darkTextColor : lightTextColor;
};

const OptInDemoTemplate = ({
  customizedTitle,
  customizedSubtitle,
  colorArray,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const convertColorArrayToObject = (array) => {
    let obj = {};

    for (let item of array) {
      obj[item.name] = item.color;
    }
    return obj;
  };

  const colorSetting = convertColorArrayToObject(colorArray);

  const {
    // primaryColor,
    hoverColor,
    backgroundColor,
    textHoverColor,
    cardColor,
    cardHoverColor,
  } = colorSetting;

  return (
    <StyledDemoTemplateContainer bgColor={backgroundColor}>
      <StyledDemoTemplate>
        <StyledHeaderContainer>
          <StyledHeaderTitle
            color={textWithDynamicColor(
              backgroundColor,
              theme.customColors.black,
              theme.customColors.grey[100]
            )}
          >
            {customizedTitle}
          </StyledHeaderTitle>
          <StyledHeaderContent
            color={textWithDynamicColor(
              backgroundColor,
              theme.customColors.grey[700],
              theme.customColors.grey[300]
            )}
          >
            {customizedSubtitle}
          </StyledHeaderContent>
        </StyledHeaderContainer>
        <StyledContentContainer>
          <StyledInputContainer>
            <StyledInput placeHolder="Enter your email here" disabled />
            <StyledInputFakeButton>
              {formatMessage({ id: "global.btn.subscribe" })}
            </StyledInputFakeButton>
          </StyledInputContainer>
          <StyledFakeButton bgColor="#229ED9">
            <i className="meta-crm-icon-ic_telegram font-size-8" />
            {formatMessage({ id: "global.btn.getTelegramAlerts" })}
          </StyledFakeButton>
          <StyledFakeButton bgColor="#7289DA">
            <i className="meta-crm-icon-ic_discord font-size-12" />
            {formatMessage({ id: "global.btn.getDiscordAlerts" })}
          </StyledFakeButton>
          <StyledContentText
            color={textWithDynamicColor(
              backgroundColor,
              theme.customColors.grey[600],
              theme.customColors.grey[400]
            )}
          >
            {formatMessage({ id: "integration.websiteOptin.templete.hint" })}
          </StyledContentText>
        </StyledContentContainer>
      </StyledDemoTemplate>
    </StyledDemoTemplateContainer>
  );
};

export default OptInDemoTemplate;
